var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFolderMove = function SvgIconFolderMove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    clipPath: "url(#icon_folder_move_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.37 2.212A1.474 1.474 0 0 1 1.842.738h1.286c.358 0 .705.131.974.369L5.777 2.58c.269.238.615.369.974.369h5.408a1.474 1.474 0 0 1 1.473 1.473v6.632a1.474 1.474 0 0 1-1.473 1.474H1.843a1.474 1.474 0 0 1-1.474-1.474zM4.053 7.367h5.894m0 0-2.456-2.21m2.456 2.21-2.456 2.21"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_folder_move_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v14H0z"
  })))));
};
export default SvgIconFolderMove;